import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import $ from "jquery";

import {featureInterface} from "../../../../interfaces/featureInterface";
import {
  setLookActiveCategory,
  setLookActiveFeature,
  setLookOpened,
} from "../../../../actions/lookFunctions";
import LookCanvasContext from "../../lookCanvasContext";
import WithZoomToFeature from "../../hocs/withZoomToFeature";
import {setShopLastPageVisited, setShopPageLeaved, setShopPageOpened} from "../../../../actions/shopFunctions";
import {getCurrentLayout} from "../../../appLayout";
import {applyNewPreset} from "../../lookNavigation/lookNavigationFunctions";
import {loaderDisable, loaderEnable} from "../../../ui/loaderView";
import {updateCanvasCount} from "../../../../actions/actionFunctions";
import {navFeatureCLick} from "../../lookNavigation/lookFunctions";
import {enableRelatedFeature} from "../../lookNavigation/lookFunctions2";
import {checkIfLookFeaturesReceived} from "../../../../api/look-api";


const WithShopFeatureVisualizeClick = (props) => {

  const {feature, children, setShopPageOpened, setLookActiveCategory, isMobile, setShopLastPageVisited, location,
    setShopPageLeaved, bvPresets, loadedPresets, updateCanvasCount} = props;

  const visualizeButtonClick = async (zoomToFeatureGroup) => {
    console.log("visualize feature", feature);

    if (Array.isArray(feature.metaData["RoomLayout"]) && feature.metaData["RoomLayout"].length) {
      const newLayoutType = +((feature.metaData["RoomLayout"][0]).replace("Layout", ""));
      const layout = getCurrentLayout();
      if (newLayoutType !== layout.type) {
        const newPreset = bvPresets.find(bvPreset => bvPreset.layout_type === newLayoutType);
        loaderEnable();
        await checkIfLookFeaturesReceived(feature.getParent()); // this receives sinks to apply faucet
        if (newPreset) {
          await applyNewPreset(newPreset, loadedPresets);
        } else {
          const layout = getCurrentLayout();
          await layout.selectLayout(newLayoutType);
        }
        navFeatureCLick(feature, true, true, true);
        enableRelatedFeature(feature, () => {}, 0);
        updateCanvasCount();
        await new Promise(resolve => setTimeout(resolve, 1000)); // this fixes scene jump
        loaderDisable();
      }
    }
    document.querySelector(".shop").classList.add("shop--closing");
    setShopLastPageVisited(location.pathname);
    $(".overlay--white2").fadeOut(800, () => {
      zoomToFeatureGroup(feature.partId, feature);
      setShopPageOpened("");
      setShopPageLeaved(true);
      if (!isMobile) {
        setTimeout(() => {
          setLookActiveCategory(feature.partId);
        }, 300)
      }
    });
  }

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => children(() => visualizeButtonClick(zoomToFeatureGroup))}
        </WithZoomToFeature>
      )}
    </LookCanvasContext.Consumer>
  )
};

WithShopFeatureVisualizeClick.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {bvPresets, loadedPresets} = store.bathroomVisualizerState;

  return {
    isMobile,
    bvPresets,
    loadedPresets,
  };
};

const mapDispatchToProps = {
  setShopPageOpened,
  setLookOpened,
  setLookActiveFeature,
  setLookActiveCategory,
  setShopLastPageVisited,
  setShopPageLeaved,
  updateCanvasCount,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithShopFeatureVisualizeClick)
)
